import * as React from "react";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { ClientAccountStore } from "../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { RegularPayment } from "../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { SinglePayment } from "../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { TransferIn } from "../../Common/PaymentsIn/TransferIn/TransferIn";
import { PaymentType, processTypeEnum } from "../../Common/Resource/Contents";

interface IEditPaymentsInProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface IEditPaymentsInState {}

export class EditPaymentsIn extends ProcessComponent<IEditPaymentsInProps, IEditPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
        };
    };

    public render(): JSX.Element {
        const { data, onChange, type } = this.props;
        return (
            <div>
                <h2>Payments in</h2>
                <SinglePayment
                    {...this.getProps("Contribution")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={type}
                    hasPaymentMethod={false}
                    processType={processTypeEnum.Quote}
                />
                <hr />
                <RegularPayment
                    {...this.getProps("Contribution")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={type}
                    hasContinue={true}
                    hasIndexation={false}
                    processType={processTypeEnum.Quote}
                />
                <hr />
                <TransferIn
                    isPost={false}
                    data={
                        this.props.data.Contribution?.[
                            SubAccountTypeHelper.isPP(type) ? "GiaTransfers" : "IsaTransfers"
                        ]
                    }
                    subAccountType={type}
                    jouneryType={processTypeEnum.Quote}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                            changes,
                            data.Contribution
                        )
                    }
                    isReview={this.props.isReview}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    onRef={(ref) => this.appendChild(ref)}
                    hasCashIsa={ClientAccountStore.getClientAccountInfo().SubAccounts.some(
                        (ele) => ele.SubAccountType == SubAccountType.CashIsa
                    )}
                    accountServiceProposition={this.props.data.AccountServiceProposition}
                />
            </div>
        );
    }
}
